// extracted by mini-css-extract-plugin
export var button = "Buttons-module--button--6okHS";
export var linkButton = "Buttons-module--linkButton--n6fSw";
export var secondaryButton = "Buttons-module--secondaryButton--1SopU";
export var textWithIconContainer = "Buttons-module--textWithIconContainer--2GkSE";
export var reversed = "Buttons-module--reversed--3Uxcc";
export var isIconOnly = "Buttons-module--isIconOnly--1UKWC";
export var contentButton = "Buttons-module--contentButton--3nAmx";
export var hasBoxShadow = "Buttons-module--hasBoxShadow--3C1RM";
export var fullWidthButton = "Buttons-module--fullWidthButton--fxELz";
export var ch2 = "Buttons-module--ch2--1HN2V";
export var ch2Container = "Buttons-module--ch2-container--3u7O8";